import Splide from '@splidejs/splide';

export default class ProductGallery extends HTMLElement {

    constructor() {
        super();
        this.carousels = this.querySelectorAll('.splide');
        this.mainCarousel = this.carousels[0];
        this.thumbnailsCarousel = this.carousels[this.carousels.length - 1];
    }

    connectedCallback() {
        let main = new Splide( this.mainCarousel, {
            type      : 'slide',
            pagination: false,
            arrows    : true,
            heightRatio: 1
        });

        let thumbnails = new Splide( this.thumbnailsCarousel, {
            fixedWidth  : 50,
            fixedHeight : 50,
            gap         : 8,
            pagination  : false,
            arrows      : false,
            isNavigation: true
        });

        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
    }

}